var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 4.75C3.375 4.54289 3.20711 4.375 3 4.375C2.79289 4.375 2.625 4.54289 2.625 4.75V9.25C2.625 9.45711 2.79289 9.625 3 9.625C3.20711 9.625 3.375 9.45711 3.375 9.25V8.5H10.875V9.25C10.875 9.45711 11.0429 9.625 11.25 9.625C11.4571 9.625 11.625 9.45711 11.625 9.25V6.25C11.625 5.42157 10.9534 4.75 10.125 4.75H7.5C7.08578 4.75 6.75 5.08579 6.75 5.5V7.75H3.375V4.75ZM10.875 6.25V7.75H7.5V5.5H10.125C10.5392 5.5 10.875 5.83579 10.875 6.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06256 7.37134C5.78744 7.37134 6.37506 6.78371 6.37506 6.05884C6.37506 5.33396 5.78744 4.74634 5.06256 4.74634C4.33769 4.74634 3.75006 5.33396 3.75006 6.05884C3.75006 6.78371 4.33769 7.37134 5.06256 7.37134ZM5.06256 6.6513C4.73534 6.6513 4.47008 6.38606 4.47008 6.05884C4.47008 5.73162 4.73534 5.46636 5.06256 5.46636C5.38978 5.46636 5.65504 5.73162 5.65504 6.05884C5.65504 6.38606 5.38978 6.6513 5.06256 6.6513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBed);
export default __webpack_public_path__ + "static/media/icon-bed.8e210a602a5e61124007e60367c90151.svg";
export { ForwardRef as ReactComponent };